import ReactDOM from 'react-dom/client'
import './app-style.css'
import TradesSavvyApp from './components/TradesSavvyApp'

// Initialize React app
ReactDOM.createRoot(document.getElementById('root')).render(
  <TradesSavvyApp />
)
